import React from 'react';
import Badge from '@atlaskit/badge';
import { SimpleTag as Tag } from '@atlaskit/tag';
import { useIntl } from '@atlassian/jira-intl';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import messages from './messages.tsx';

export const StoryPointsItem = ({ value }: { value?: number }) => {
	const { formatMessage } = useIntl();

	return isVisualRefreshEnabled() ? (
		<Badge
			testId="business-list.ui.list-view.group-item.storypoints-item.storypoints"
			appearance="default"
		>
			{typeof value === 'number'
				? formatMessage(messages.storyPoints, {
						points: value,
					})
				: formatMessage(messages.noStoryPoints)}
		</Badge>
	) : (
		<Tag
			testId="business-list.ui.list-view.group-item.storypoints-item.storypoints"
			text={
				typeof value === 'number'
					? formatMessage(messages.storyPoints, {
							points: value,
						})
					: formatMessage(messages.noStoryPoints)
			}
		/>
	);
};
